import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";

//Components
import Loading from "../../../components/Loading/Loading";
import MainCard from "../../../components/MainCard/MainCard";
import { showMessage } from "../../../helpers/message";
import FiltroPrefeitura from "views/Shared/FiltroPrefeitura";

//Api
import dashboard_api from "../../../api/dashboard_api";
import gerador_api from "../../../api/gerador_api";
import transportador_api from "../../../api/transportador_api";

import RelatorioGeradoresSemContratoEPendente from "./RelatorioGeradoresSemContratoEPendente";

function initialStateFiltros() {
  return {
    cnpj: "",
    razao: "",
    transportadorId: "",
    transportadorNome: "",
    situacao: "Todos",
  };
}

export default function GeradoresSemContratoEPendente() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState(initialStateFiltros());
  const [dadosRelatorio, setDadosRelatorio] = useState([]);
  const [prefeitura_Id, setPrefeitura_Id] = useState(null);
  
  const [transportadores, setTransportadores] = useState([]);

  useEffect(() => {
    carregarTransportadores();
  }, []);

  const carregarTransportadores = () => {
    transportador_api.GetAll()
      .then(res => {
        let options = res.data.map(t => ({ value: t.id, label: t.fantasia }));
        options.unshift({ value: "", label: "Todos" });
        setTransportadores(options);
      })
      .catch(e => console.error(e));
  };

  const aplicarFiltrosLocais = (listaBase) => {
    return listaBase.filter(item => {
        let passaCnpj = true;
        let passaRazao = true;
        let passaTransp = true;

        if (filtros.cnpj) {
            passaCnpj = item.cpfcnpj && item.cpfcnpj.includes(filtros.cnpj);
        }
        if (filtros.razao) {
            const fantasiaMatch = item.fantasia && item.fantasia.toLowerCase().includes(filtros.razao.toLowerCase());
            const razaoMatch = item.razao && item.razao.toLowerCase().includes(filtros.razao.toLowerCase());
            passaRazao = fantasiaMatch || razaoMatch;
        }
        if (filtros.transportadorNome && filtros.transportadorNome !== "Todos" && filtros.transportadorNome !== "") {
            passaTransp = item.transportador && item.transportador === filtros.transportadorNome;
        }

        return passaCnpj && passaRazao && passaTransp;
    });
  };

  const handleGerarRelatorio = async () => {
    if (!prefeitura_Id) {
      showMessage("Aviso", "Selecione uma prefeitura", "warning");
      return;
    }

    setLoading(true);
    try {
      let listaGeral = [];

      // Para 'Sem Contrato' ou 'Todos'
      if (filtros.situacao === "Sem Contrato" || filtros.situacao === "Todos") {
        const resSem = await gerador_api.GetListSemContrato({ 
          prefeitura_id: prefeitura_Id, 
          status: "Todos", 
          isRelatorio: true,
          cnpj: filtros.cnpj,
          razao: filtros.razao,
          transportadorId: filtros.transportadorId ? parseInt(filtros.transportadorId) : null
        });
        
        let mappedSem = resSem.data.map(g => ({
          ...g,
          transportador: "-",
          motivoContratoPendente: "-",
          situacaoContrato: "Sem Contrato"
        }));
        listaGeral = [...listaGeral, ...mappedSem];
      }

      // Para 'Contratos Pendentes' ou 'Todos'
      if (filtros.situacao === "Contratos Pendentes" || filtros.situacao === "Todos") {
        const resPend = await dashboard_api.GeradoresContratos(prefeitura_Id, "Contrato Pendente", true);
        let mappedPend = resPend.data.map(g => ({
          ...g,
          situacaoContrato: "Contrato Pendente"
        }));
        listaGeral = [...listaGeral, ...mappedPend];
      }

      const dadosFiltrados = aplicarFiltrosLocais(listaGeral);
      setDadosRelatorio(dadosFiltrados);

    } catch (e) {
      showMessage("Erro", e.message || "Erro ao carregar dados", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePrefeitura = (value) => {
    setPrefeitura_Id(value);
  };

  if (dadosRelatorio.length > 0) {
    return (
      <RelatorioGeradoresSemContratoEPendente
        dadosRelatorio={dadosRelatorio}
        btnVoltar={() => {
          setDadosRelatorio([]);
          setFiltros(initialStateFiltros());
        }}
        filtros={filtros}
      />
    );
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
      <h4>Relatório de Geradores Sem Contrato E Pendente</h4>
      <div className="mt-4">
        <Row>
          <Col md={3}>
            <FormGroup>
              <Label>Situação</Label>
              <Input type="select" value={filtros.situacao} onChange={e => setFiltros({...filtros, situacao: e.target.value})}>
                <option value="Todos">Todos</option>
                <option value="Sem Contrato">Sem Contrato</option>
                <option value="Contratos Pendentes">Contratos Pendentes</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>CNPJ</Label>
              <Input type="text" placeholder="Todos" value={filtros.cnpj} onChange={e => setFiltros({...filtros, cnpj: e.target.value})} />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Razão Social / Fantasia</Label>
              <Input type="text" placeholder="Todos" value={filtros.razao} onChange={e => setFiltros({...filtros, razao: e.target.value})} />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Transportador</Label>
              <Select
                options={transportadores}
                placeholder="Todos"
                value={transportadores.find(t => t.value === filtros.transportadorId) || { value: "", label: "Todos" }}
                onChange={val => setFiltros({
                   ...filtros, 
                   transportadorId: val.value, 
                   transportadorNome: val.label === "Todos" ? "" : val.label 
                })}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-right mt-3">
             <Button color="primary" onClick={handleGerarRelatorio}>
                Gerar Relatório
             </Button>
          </Col>
        </Row>
      </div>
    </MainCard>
  );
}
